import { useContext } from 'react';
import { useLocation, UNSAFE_NavigationContext as NavigationContext } from 'react-router';
import { normalizePath } from '@helsenorge/core-utils/url';
import { filterByPathname, filterByFeatureToggle, filterByScope, filterByPosition, filterByComponent } from './survey-filters';
import { getSurveysCookie } from './utils';
import { useGetAdditionalPageContentQuery } from '.';
/**
 * Hent og filtrer undersøkelser basert på gitte kriterier.
 *
 * @param options - Objekt som inneholder språk og posisjon for undersøkelsene.
 * @returns En liste over filtrerte undersøkelser eller undefined hvis ingen er funnet.
 */
function useSurveys({ languageCode, position, component }) {
    const { data, ...rest } = useGetAdditionalPageContentQuery({ languageCode });
    const { pathname: rawPathname } = useLocation();
    const navContext = useContext(NavigationContext);
    const basename = navContext?.basename;
    const pathname = normalizePath(basename, rawPathname);
    const surveyCookie = getSurveysCookie();
    const surveys = data?.surveys
        .filter(survey => filterByPathname(survey, pathname))
        .filter(filterByFeatureToggle)
        .filter(filterByScope)
        .filter(survey => (position ? filterByPosition(survey, position) : true))
        .filter(survey => (component ? filterByComponent(survey, component) : true))
        .filter(survey => !surveyCookie || !(survey.id in surveyCookie));
    return { data: surveys, ...rest };
}
export default useSurveys;
